import { useState } from 'react';
import { Layout, Menu } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  DollarCircleOutlined,
  DashboardOutlined,
  CompassOutlined,
  MoneyCollectOutlined,
  SettingOutlined,
  MailOutlined,
  BookOutlined,
} from '@ant-design/icons';
import logo from '../assets/water-drop.png';
import { useHistory } from 'react-router-dom';
import SubMenu from 'antd/lib/menu/SubMenu';
import auth from '../lib/services';

interface Props {
  children: any;
}

const { Sider, Content } = Layout;

export default function DashLayout({ children }: Props) {
  const [collapsed] = useState(false);
  const history = useHistory();

  const logout = () => {
    localStorage.removeItem('token');
    history.push('/');
  };

  const goTo = (url: string) => {
    history.push(url);
  };

  const role = auth.getRole();

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed} width="auto">
        <div className="mb-5 flex flex-row bg-white py-3 justify-center pr-3 items-center">
          <img src={logo} className="h-10" alt="logo" />
          <p className="mt-5 font-bold">Smart Water</p>
        </div>
        <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
          {role.dashboard && (
            <Menu.Item
              key="1"
              icon={<DashboardOutlined />}
              onClick={() => goTo('/dashboard')}
            >
              Dashboard{' '}
            </Menu.Item>
          )}
          {role.customers && (
            <Menu.Item
              key="2"
              icon={<UserOutlined />}
              onClick={() => goTo('/customers')}
            >
              Customers
            </Menu.Item>
          )}
          {role.billings && (
            <Menu.Item
              key="3"
              icon={<DollarCircleOutlined />}
              onClick={() => goTo('/billings')}
            >
              Billings
            </Menu.Item>
          )}
          {role.meters && (
            <Menu.Item
              key="5"
              icon={<CompassOutlined />}
              onClick={() => goTo('/meters')}
            >
              Meters
            </Menu.Item>
          )}
          {role.rates && (
            <Menu.Item
              key="6"
              icon={<DollarCircleOutlined />}
              onClick={() => goTo('/rates')}
            >
              Rates
            </Menu.Item>
          )}
          {role.payments && (
            <Menu.Item
              key="8"
              icon={<DollarCircleOutlined />}
              onClick={() => goTo('/payments')}
            >
              Payments
            </Menu.Item>
          )}
          {role.user_management && (
            <SubMenu key="7" icon={<MailOutlined />} title="Users Role">
              <Menu.Item
                key="9"
                icon={<UserOutlined />}
                onClick={() => goTo('/users-role/users')}
              >
                Users
              </Menu.Item>
              <Menu.Item
                key="10"
                icon={<BookOutlined />}
                onClick={() => goTo('/users-role/roles')}
              >
                Roles
              </Menu.Item>
            </SubMenu>
          )}
          {role.additional_fees && (
            <Menu.Item
              key="12"
              icon={<MoneyCollectOutlined />}
              onClick={() => goTo('/additional-fees')}
            >
              Additional Fees
            </Menu.Item>
          )}
          {role.settings && (
            <Menu.Item
              key="13"
              icon={<SettingOutlined />}
              onClick={() => goTo('/settings')}
            >
              Settings
            </Menu.Item>
          )}
          <Menu.Item
            key="4"
            icon={<LogoutOutlined />}
            onClick={() => goTo('/logout')}
          >
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Content
          style={{
            height: '100vh',
            paddingTop: 50,
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}
